import React, {useRef} from "react";
import Flickity from "react-flickity-component";
import ProductSliderTile from "../insect-calendar/ProductSliderTile";
import ChevronLeft from "../icons/ChevronLeft";
import ChevronRight from "../icons/ChevronRight";

export default ({insect, index}) => {

    const relatedSlider = useRef();

    return <div className="problem-solver__result">
        <div className="problem-solver__result__inner">
            <h4 className="problem-solver__result__number">{index}.</h4>
            <h2 className="problem-solver__result__title">{insect.title}</h2>
            {!!insect.insect_image && <div className="problem-solver__result__image">
                <img src={insect.insect_image} alt={insect.title_problem_solver} />
            </div>}
            <div className="problem-solver__result__body">
                <div className="problem-solver__result__hero">
                    <h2>{insect.title_problem_solver}</h2>
                </div>
                <div className="problem-solver__result__text">
                    <div dangerouslySetInnerHTML={{__html: insect.content_problem_solver}} />
                    <div className="problem-solver__result__action">
                        <a href={insect.link} className="btn btn--blue--solid btn--blue">Calendar page</a>
                    </div>
                </div>
            </div>

            {insect.products.length > 0 && <div className="problem-solver__result__related">
                <h3>Related products</h3>
                <div className="problem-solver__result__related-list">
                    <Flickity ref={relatedSlider} options={{cellAlign: 'left', pageDots: true, contain: true, prevNextButtons: false}}>
                        {insect.products.map((product) => {
                            return <ProductSliderTile key={`product__${product.id}`} product={product} />
                        })}
                    </Flickity>

                    <div className="insect-page__calendar__popup__buttons">
                        <a onClick={(e) => {
                            e.preventDefault();
                            relatedSlider.current.flkty.previous();
                            return false;
                        }}>
                            <ChevronLeft />
                        </a>
                        <a onClick={(e) => {
                            e.preventDefault();
                            relatedSlider.current.flkty.next();
                            return false;
                        }}>
                            <ChevronRight />
                        </a>
                    </div>

                </div>
            </div>}

        </div>
    </div>;

}
